(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("constants", [], factory);
	else if(typeof exports === 'object')
		exports["constants"] = factory();
	else
		root["constants"] = factory();
})(this, function() {
return 